<template>
    <!-- Filters container -->
    <div class="row d-flex align-items-center m-0 mt-4 pb-3">
        <!-- Filter search container -->
        <div ref="searchContainer"
            class="col-12 col-md-5 col-lg-3 searchInputContainer gap-2 rounded-pill bg-white border-gray-500">
            <!-- Search icon -->
            <i class="bi-search inline-icon text-body"></i>
            <div class="input-group">
                <!-- Search input -->
                <input ref="searchInput" class="form-control p-0 border-0 bg-white active-border h-24" type="text"
                    placeholder="Type to filter" v-model="search" @keyup="toggleClearButton">
                <!-- Clear button -->
                <span class="input-group-append" @click="clearSearchInput">
                    <i ref="clearIcon" class="bi bi-x inline-icon d-none"></i>
                </span>
            </div>
        </div>

        <!-- Filter buttons -->
        <Swiper class="col-12 col-md-7 col-lg-9 p-0 mt-3 mt-md-0 gap-3 filters-swiper" tag="div">
            <template #content>
                <!-- Popup filter buttons -->
                <button v-for="(filter, index) in modifiableFilterOptions.filter(f => f.type == 'popup')"
                    class="btn border-gray-500 rounded-pill d-flex align-items-center p-filter-btn"
                    :data-bs-toggle="'modal'" :data-bs-target="'#fModal-' + compUID + '-' + index"
                    :class="(selectedFilters.find(f => f.label == filter.label) && selectedFilters.find(f => f.label == filter.label)?.value !== null) || (filter.forSort && filter.options.find(f => f.value == sortBy) != null) ? 'bg-dark text-light border-dark' : ''">
                    <i class="bi inline-icon" :class="filter.forSort ? 'bi-sort-down' : 'bi-filter'"
                        :title="filter.forSort ? 'Sort' : 'Filter'"></i>
                    <span class="h-24 ms-1" v-if="filter.forSort">
                        {{ filter.options.find(f => f.value == sortBy)?.label ?? filter.label }}
                    </span>
                    <span class="h-24 ms-1" v-else>
                        {{ selectedFilters.find(f => f.label == filter.label)?.optLabel ?? filter.label }}
                    </span>
                </button>
                <!-- Other filter buttons -->
                <button v-for="(filter, index) in modifiableFilterOptions.filter(f => f.type == 'selection')"
                    :id="'filter-' + compUID + '-' + index"
                    class="btn border-gray-500 rounded-pill d-flex align-items-center p-filter-btn bg-transparent"
                    @click="selectedFilters.find(f => f.value == filter.value) ? removeFilter($event, filter) : setFilter($event, filter)">
                    <span class="h-24">{{ filter.label }}</span>
                </button>
            </template>
        </Swiper>
    </div>

    <!-- Divider -->
    <div class="divider sm" :class="selectedFilters.filter(f => f.type == 'selection').length ? 'mb-0' : 'mb-2'"></div>

    <!-- Popup filter modal -->
    <div class="modal fade" tabindex="-1" :id="'fModal-' + compUID + '-' + index"
        :aria-labelledby="'fModal-' + compUID + '-' + index + 'Label'" aria-hidden="true"
        v-for="(filter, index) in modifiableFilterOptions.filter(f => f.type == 'popup')">
        <div class="modal-dialog modal-dialog-centered sheetModal popOutModal">
            <div class="modal-content rounded-sm">
                <div class="modal-body d-flex flex-column py-4 px-0 align-items-center">
                    <ul class="list-group text-start w-100">
                        <!-- Default First Option -->
                        <li v-if="!filter.forSort"
                            class="popover-item cursor-pointer d-flex align-items-center list-group-item fs-6 border-0">
                            <input class="form-check-input mt-0" type="radio" :id="'po-' + compUID + '-' + index + '-'"
                                :checked="null == selectedFilters.find(f => f.label == filter.label)?.value"
                                @click="setPopupValue(filter, null)" data-bs-dismiss="modal">
                            <label class="form-check-label cursor-pointer p-2 flex-grow-1"
                                :for="'po-' + compUID + '-' + index + '-'">
                                {{ filter.label }} (UNFILTERED)
                            </label>
                        </li>
                        <!-- Option item -->
                        <li class="popover-item cursor-pointer d-flex align-items-center list-group-item fs-6 border-0"
                            v-for="option in filter.options">
                            <!-- To Deal with String and Number -->
                            <input v-if="(typeof option == 'string' || typeof option == 'number')"
                                class="form-check-input mt-0" type="radio"
                                :id="'po-' + compUID + '-' + index + '-' + option"
                                :checked="option == selectedFilters.find(f => f.label == filter.label)?.value"
                                @click="setPopupValue(filter, option)" data-bs-dismiss="modal">
                            <label v-if="(typeof option == 'string' || typeof option == 'number')"
                                class="form-check-label cursor-pointer p-2 flex-grow-1"
                                :for="'po-' + compUID + '-' + index + '-' + option">
                                {{ option }}
                            </label>

                            <!-- To Deal with Object -->
                            <input v-if="(typeof option !== 'string' && typeof option !== 'number')"
                                class="form-check-input mt-0" type="radio"
                                :id="'po-' + compUID + '-' + index + '-' + option.value"
                                :checked="(option.value == selectedFilters.find(f => f.label == filter.label)?.value) || (filter.forSort && option.value == sortBy)"
                                @click="setPopupValue(filter, option.value, option.label)" data-bs-dismiss="modal">
                            <label v-if="(typeof option !== 'string' && typeof option !== 'number')"
                                class="form-check-label cursor-pointer p-2 flex-grow-1"
                                :for="'po-' + compUID + '-' + index + '-' + option.value">
                                {{ option.label }}
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- Selected filters container -->
    <div class="row mx-0 mt-3 selected-filters"
        :class="selectedFilters.filter(f => f.type == 'selection').length ? 'd-flex' : 'd-none'">
        <Swiper class=" py-0 gap-2 selected-filters-swiper" tag="div">

            <template #content>
                <!-- Filter item -->
                <button class="btn btn-dark rounded-pill d-flex align-items-center py-2 px-3"
                    v-for="option in selectedFilters.filter(f => f.type == 'selection') ">
                    <p class="m-0">{{ option.label }}</p>
                    <i class="bi bi-x inline-icon ms-2" @click="removeFilter($event, option, true)"></i>
                </button>
            </template>
        </Swiper>
    </div>
</template>

<script setup>
import { ref, watch, watchEffect, onMounted } from "vue";
import Swiper from "../Swiper.vue";
import { useDebounceFn } from "@vueuse/core";
import { useFilterHelper } from "@/composables/useFilterHelper.js";
import { v4 as uuidv4 } from "uuid";

const props = defineProps({
    filterOptions: Array,
    sort: String,
    sort_dir: String
})

const emits = defineEmits(['filters-updated']);
const filterHelper = useFilterHelper();

const clearIcon = ref(null);
const searchContainer = ref(null);
const searchInput = ref(null);
const selectedFilters = ref([]);
const lastScrollPos = ref(null);
const compUID = ref(uuidv4());

const queryParams = ref({});
const modifiableFilterOptions = ref(props.filterOptions ? props.filterOptions : []);
const search = ref('');
const sortBy = ref(props.sort ? props.sort : "name");
const sortDirection = ref(props.sort_dir ? props.sort_dir : "asc");
const filters = ref([]);

const updateFilters = () => {
    filters.value = [];
    modifiableFilterOptions.value?.forEach(filter => {
        let dbTable = '';
        if (filter.dbTable) {
            dbTable = filter.dbTable + '.';
        }
        let dbHaving = '';
        if (filter.havingClause) {
            dbHaving = 'having_';
        }

        let searchMethod = 'normal';
        if (filter.searchMethod) {
            searchMethod = filter.searchMethod;
        }

        if ((filter.selected && filter.selected.length != 0) || filter.selected === '' || filter.selected === 0) {
            if (filter.dbFieldType && filter.cond) {
                filters.value.push([dbHaving + dbTable + filter.filterOn, filter.selected, searchMethod, filter.dbFieldType, filter.cond])
            }
            else if (filter.dbFieldType) {
                filters.value.push([dbHaving + dbTable + filter.filterOn, filter.selected, searchMethod, filter.dbFieldType])
            }
            else if (filter.cond) {
                filters.value.push([dbHaving + dbTable + filter.filterOn, filter.selected, searchMethod, 'string', filter.cond])
            }
            else {
                filters.value.push([dbHaving + dbTable + filter.filterOn, filter.selected, searchMethod])
            }
        }
    });
    queryParams.value = filterHelper.generate(search, sortBy, sortDirection, filters.value);
}

const debounceFilterUpdate = useDebounceFn(async () => {
    emits('filters-updated', queryParams.value);
}, 600);

const removeFilter = (event, filter, removedBySelection = false, elId) => {
    selectedFilters.value = selectedFilters.value.filter(o => o.label != filter.label);

    const filterIndex = modifiableFilterOptions.value.filter(f => f.type == "selection").findIndex((o) => o.label == filter.label);

    if (filterIndex !== -1) {
        modifiableFilterOptions.value[filterIndex].selected = null;
    }

    if (removedBySelection) {
        document.querySelector(`#filter-${compUID.value}-${filterIndex}`).classList.remove("border-dark");
    }
    else {
        event.target.closest('button').classList.remove("border-dark");
    }
}

const setFilter = (event, filter) => {
    let selObj = {
        label: filter.label,
        type: filter.type,
        value: filter.value,
        optLabel: filter.label
    }
    selectedFilters.value.push(selObj);

    let filterIndex = modifiableFilterOptions.value?.findIndex(obj => obj.label == filter.label);
    if (filterIndex !== -1) {
        modifiableFilterOptions.value[filterIndex].selected = filter.value;
    }

    event.target.closest('button').classList.add("border-dark")
};

const toggleClearButton = () => {
    if (searchInput.value.value.length > 0) {
        clearIcon.value.classList.remove("d-none");
    } else {
        clearIcon.value.classList.add("d-none");
    }
}

const clearSearchInput = () => {
    search.value = '';
    searchInput.value.value = "";
    searchInput.value.blur();
    clearIcon.value.classList.add("d-none");
}

const setPopupValue = (filter, val, label = null) => {
    if (filter.forSort) {
        let tempDir = filter.options.filter(opt => opt.value == val);
        sortBy.value = val;
        if (tempDir.length) {
            sortDirection.value = tempDir[0].dir ? tempDir[0].dir : '';
        }
        else {
            sortDirection.value = 'asc';
        }
        return;
    }
    let selObj = {
        label: filter.label,
        type: filter.type,
        value: val,
        optLabel: label ? label : val
    }
    selectedFilters.value = selectedFilters.value.filter(f => f.label != filter.label);
    selectedFilters.value.push(selObj);

    const filterIndex = modifiableFilterOptions.value.filter(f => f.type == "popup").findIndex((o) => o.label == filter.label);

    if (filterIndex !== -1) {
        modifiableFilterOptions.value[filterIndex].selected = val;
    }
}

const resetFilters = () => {
	selectedFilters.value = [];
	modifiableFilterOptions.value.forEach(filter => {
		filter.selected = null;
	});
	search.value = '';
	searchInput.value.value = '';
	sortBy.value = props.sort ? props.sort : "";
	sortDirection.value = props.sort_dir ? props.sort_dir : "asc";
	clearIcon.value.classList.add("d-none");
	emits('filters-updated', {});
}

watch([() => props.sort, () => props.sort_dir], () => {
	sortBy.value = props.sort ? props.sort : "";
	sortDirection.value = props.sort_dir ? props.sort_dir : "asc";
})

watchEffect(() => {
	updateFilters();
});

watch(queryParams, (val) => {
	debounceFilterUpdate();
}, { immediate: true });

watch(() => props.filterOptions, (val) => {
	if (val && val.length > 0) {
		modifiableFilterOptions.value = val;
	} else {
		modifiableFilterOptions.value = [];
	}
}, { immediate: true });

onMounted(() => {
	let modalEls = document.querySelectorAll('.modal');
	modalEls.forEach(modalEl => {
		modalEl.addEventListener('hide.bs.modal', () => {
			modalEl.querySelector('.modal-dialog').classList.add('closing');
			setTimeout(() => {
				modalEl.querySelector('.modal-dialog').classList.remove('closing');
			}, 500)
		})
	})
});

defineExpose({
	resetFilters,
});

</script>

<style scoped lang="scss">
.selected-filters {
    margin-bottom: 10px;

    @media (max-width: 992px) {
        margin-bottom: 7px;
    }
}

.searchInputContainer {
    &:focus-within {
        border: 1px solid #0f0f0f !important;
    }
}

.h-24 {
    height: 24px;
}

.p-filter-btn {
    padding: 0.6rem 1.1rem;
}
</style>./Swiper.vue